const LinerIcon = /*#__PURE__*/ [
  ["path", { d: "M3 20L21 4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export { LinerIcon as default };
//# sourceMappingURL=LinerIcon.js.map
